const userMngt = {
    namespaced: true,
    state : {
        clinicDoctorId : '',
        clinicDoctorClass : '',
        clinicDoctorInfo : null
    },
    getters: {
        getClinicDoctorId (state) {
            return state.clinicDoctorId
        },
        getClinicDoctorClass (state) {
            return state.clinicDoctorClass
        },
        getClinicDoctorInfo (state) {
            return state.clinicDoctorInfo
        }
    },
    mutations: {
        setClinicDoctorId (state, payload) {
            state.clinicDoctorId = payload
        },
        setClinicDoctorClass (state, payload) {
            state.clinicDoctorClass = payload
        },
        setClinicDoctorInfo (state, payload) {
            state.clinicDoctorInfo = payload
        }
    },
    actions: {
        setClinicDoctorId ({commit}, payload) {
            commit('setClinicDoctorId', payload)
        },
        setClinicDoctorClass ({commit}, payload) {
            commit('setClinicDoctorClass', payload)
        },
        setCodeMngtInit ({commit}) {
            commit('setClinicDoctorId', '');
            commit('setClinicDoctorClass', '');
        },
        setClinicDoctorInfo ({commit},payload) {
            commit('setClinicDoctorInfo', payload)
        }
    }
}


export default userMngt